/* eslint-disable camelcase */
export var RecordingType;
(function (RecordingType) {
    RecordingType[RecordingType["Global"] = 5] = "Global";
    RecordingType[RecordingType["URL"] = 6] = "URL";
    RecordingType[RecordingType["ET_Page"] = 8] = "ET_Page";
    RecordingType[RecordingType["ET_Session"] = 9] = "ET_Session";
})(RecordingType || (RecordingType = {}));
//# sourceMappingURL=recording-type.js.map